import { useMemo } from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../redux/hooks';
import { SvgIcon } from '../Icon';
import RightSideBarIcon from './RightSideBarIcon';
import { theme } from '../../styles/theme';

interface IProps {
  onClick: () => void;
  isActive: boolean;
}

const StyledUnreadIndicator = styled(SvgIcon)`
  position: absolute;
  top: 3px;
  right: 3px;
`;

const CommentsToggle = ({ onClick, isActive }: IProps) => {
  const threads = useAppSelector((state) => state.conversationThreads.threads);

  // Show a small red dot when user has unread comments
  const hasUnreadComments = useMemo(() => {
    if (!threads.length) {
      return false;
    }
    return threads.some((thread) => thread.hasUnreadComments);
  }, [threads]);

  return (
    <RightSideBarIcon
      active={isActive}
      onClick={onClick}
      icon="chat-teardrop"
      content={'Comments'}
      trackContext="comments"
      trackAction={isActive ? 'close' : 'open'}
    >
      {hasUnreadComments && (
        <StyledUnreadIndicator
          name="dot-outline-fill"
          width={24}
          height={24}
          customFill={theme.colors.red500}
        />
      )}
    </RightSideBarIcon>
  );
};

export default CommentsToggle;
